import { gql } from "gql";

export const GET_POSTS = gql(/* GraphQL */ `
  query GetPosts($page: PageRequest, $commentsCount: Int! = 100) {
    getPosts(page: $page) {
      content {
        ...BasePost
      }
      total
    }
  }
`);
